
        import { showModal } from './src/lib/utils/showModal'

        const search = Object.fromEntries(
          new URLSearchParams(window.location.search),
        )
        console.log('[index.html] search →', JSON.stringify(search, null, 2))
        const error = search?.error
        if (error) {
          // Send error to Sentry
          if (typeof window !== 'undefined' && window.Sentry) {
            window.Sentry.captureMessage('Error from URL parameters', {
              level: 'error',
              tags: {
                error_type: error,
                source: 'index.html',
              },
              extra: {
                error,
                error_description: search?.error_description,
                email: search?.email,
                search_params: search,
                url: window.location.href,
                referrer: window.location.referrer,
              },
            })
          }
          showModal({id: error})
        }
      